import store from "@/store";
export const option = {
  height: "auto",
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: "客户资料",
  editTitle: "客户资料",
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: true,
  indexLabel: "序号",
  selection: true,
  viewBtn: false,
  dialogType: "dialog",
  dialogClickModal: false,
  rowKey: "index",
  column: [
    {
      label: "审批编号",
      prop: "businessNormalFlowableId",
      display: false,
      search: true,
      hide:false,
      searchOrder: 555,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      searchPlaceholder: "请输入租赁人",
      display: false,
      searchOrder: 777,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      display: false,
      search: true,
      searchOrder: 444,
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      display: false,
      search: true,
      searchOrder: 666,
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      display: false,
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
      searchOrder: 888,
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: [],
      searchOrder: 999,
      props: {
        label: "title",
        value: "id",
      },
    },

    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      display: false,
      search: false,
      searchMultiple: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      span: 24,
      display: false,
      search: false,
    },
    {
      label: "申请时间",
      prop: "flowCreateTime",
      span: 24,
      display: false,
      search: false,
    },
    {
      label: "借用数量",
      prop: "sqAmount",
      span: 24,
      search: false,
      display: false,
    },
    // {
    //   label: "位置",
    //   prop: "storageLocationManagementName",
    //   span: 24,
    //   search: false,
    //   display: false,
    // },
    {
      label: "id",
      prop: "id",
      display: false,
      hide: true,
    },

  ],
};
